<template>
    <div class="row">
        <div class="col-12 text-center">
            <div class="mt-4" v-if="selectedPayments.length <= 0">
                <h2 class="segment-primary-color" v-if="totalPayments"> {{ currencyFormat(totalPayments) }}</h2>
                <div v-else-if="loading" class="row d-flex font-weight-bolder justify-content-center mt-2">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw mt-4"></i>
                </div>
                <span v-if="hasPayments">VALOR TOTAL DAS {{ payments.length }} PARCELAS ATRASADAS</span><br>
            </div>
            <div class="mt-4 mb-2" v-else>
                <div class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                        <h3>{{ currencyFormat(totalSelected) }}</h3>
                    </div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                        <h3 style="color: red;">{{ currencyFormat(totalFees) }}</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6"><small>Valor selecionado</small></div>
                    <div class="col-6 col-sm-6 col-md-6 col-lg-6"><small style="color: red;">Juros</small></div>
                </div>
                <div v-if="totalPayments" class="mt-4 d-flex justify-content-center">
                    <button type="button" @click="visible = true"
                        class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">Quero
                        quitar o débito</button>
                </div>
            </div>
            <div v-if="temSegundaVia" class="mt-3 mx-4 p-3" style="background-color: rgba(255, 152, 0, 0.15); border-radius: 10px;">
                <span class="font-weight-bold" style="color: rgba(180, 100, 0, 1); font-size: 13px;">
                    Você possui uma segunda via em aberto. Verifique na aba de parcelas Futuras.
                </span>
            </div>
            <span v-if="hasPayments" style="font-size: 14px;">Selecione parcelas para pagar</span>
            <div v-if="!loading && !hasPayments" class="mb-4">
                <span class="segment-primary-color font-weight-bolder mb-4" style="font-size: 15px;">SEM PARCELAS
                    ATRASADAS</span>
            </div>
        </div>
        <!-- <div v-for="payment in payments" :key="payment.par_in_codigo" class="mt-2 d-flex justify-content-center mb-2">
            <div class="col-lg-8 col-12">
                <div class="card h-100">
                    <div class="card-body pt-0">
                        <ul class="list-group list-group-flush" data-toggle="checklist">
                            <li class="checklist-entry list-group-item px-0">
                                <div class="checklist-item checklist-item-success d-flex">
                                    <div class="checklist-info">
                                        <div style="font-size: 12px;"><span class="mb-0 text-bold">Parcela {{
                                            payment.par_in_codigo }}</span></div>
                                        <div class="text-xs mb-0 mt-1"><span class="text-bold">Vencimento em </span>{{
                                            formatDate(payment.par_dt_vencimento) }}</div>
                                        <div class="text-xs mb-0 mt-1"><span class="text-bold">Tipo: </span>{{
                                            payment.par_ch_parcela }}</div>
                                        <div class="text-xs mb-0 mt-1"><span class="text-bold">Origem: </span>{{
                                            payment.par_origem_parcela }}</div>
                                        <div class="text-xs mb-0 mt-1">
                                            <span class="text-bold">Situação: </span>{{ 'EM ATRASO' }}
                                        </div>
                                        <div class="mt-2">
                                            <h5 class="text-bold" style="color: red;">{{
                                                currencyFormat(payment.valorcorrigido) }}</h5>
                                        </div>
                                    </div>
                                    <div class="form-check my-auto ms-auto">
                                        <input :id="payment.par_in_codigo" class="form-check-input" type="checkbox"
                                            style="width: 30px;height: 30px;"
                                            @change="toggleSelection(payment.par_in_codigo)" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> -->

        <div v-if="hasPayments" class="mt-2 d-flex justify-content-center mb-2 ms-2">
            <table class="table align-items-center mb-0">
                <thead>
                    <tr class="mb-2 ms-2">
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Parcela
                        </th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Valor</th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Vencimento
                        </th>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Ações
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="payment in payments" :key="payment.par_in_codigo">
                        <td>
                            <div class="d-flex px-2 py-1">
                                <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-xs">{{ payment.par_in_codigo }}</h6>
                                    <p class="text-xs text-secondary mb-0">EM ATRASO</p>
                                </div>
                            </div>
                        </td>
                        <td>
                            <span class="text-xs font-weight-bold mb-0">{{ currencyFormat(payment.valorcorrigido) }}</span>
                        </td>
                        <td>
                            <p class="text-xs font-weight-bold mb-0">{{ formatDate(payment.par_dt_vencimento) }}</p>
                        </td>
                        <td>
                            <div class="form-check my-auto ms-auto">
                                <input :id="payment.par_in_codigo" class="form-check-input" type="checkbox"
                                    style="width: 30px;height: 30px;"
                                    @change="toggleSelection(payment.par_in_codigo)" />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <Dialog v-model:visible="visible" modal header="Quitar Atraso" :style="{ width: '25rem' }">
        <div class="d-flex justify-content-center">
            <h5>{{ currencyFormat(totalFees + totalSelected) }}</h5>
        </div>
        <div class="row">
            <div>VALOR: <span> {{ currencyFormat(totalSelected) }}</span></div>
            <div>JUROS: <span style="color: red;">+{{ currencyFormat(totalFees) }}</span></div>
        </div>

        <div class="mt-4 col-12 col-sm-12 col-md-12 col-lg-12 mt-2 mt-sm-0">
            <label>Como deseja quitar os débitos</label>
            <Dropdown v-model="selectedOption" :options="options" optionLabel="name" placeholder="" class="w-100" />
        </div>
        <div class="mt-2 col-12 col-sm-12 col-md-12 col-lg-12 mt-2 mt-sm-0">
            <label>Data de pagamento</label>
            <argon-input id="date" v-model="date" class="multisteps-form__input" type="text" placeholder="DD/MM/YYYY"
                v-maska="'##/##/####'" />
            <small style="font-size: 10px; margin-top: 0px;">Você precisa selecionar uma data que seja pelo menos o
                próximo dia útil</small>
        </div>
        <div class="mt-4 col-12 col-sm-12 col-md-12 col-lg-12 mt-2 mt-sm-0">
            <label>Enviar boleto para</label>
            <argon-input id="mail" v-model="email" class="multisteps-form__input" type="mail"
                placeholder="mail@mail.com.br" />
        </div>
        <div class="mt-4 d-flex justify-content-center">
            <button :disabled="loadingButton" type="button" @click="sendRequest()"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center">
                Confirmar <i v-if="loadingButton" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>
    </Dialog>
</template>

<script setup>
import axios from "axios";
import { computed, onMounted, ref } from "vue";
import moment from 'moment';
import { useStore } from "vuex";
import Dialog from 'primevue/dialog';
import ArgonInput from "@/components/ArgonInput.vue";
import Dropdown from 'primevue/dropdown';
import { showToast } from "@/assets/js/toast.js";

const loading = ref(true);
const loadingButton = ref(false);
const store = useStore();
const contractData = computed(() => store.getters.getCurrentContract);
const payments = ref([]);
const totalPayments = ref(0);
const totalSelected = ref(0);
const totalFees = ref(0);
const selectedPayments = ref([]);
const visible = ref(false);
const selectedOption = ref();
const date = ref();
const email = ref();


const options = ref([
    { name: 'Solicitar Renegociação', code: 1 },
    { name: 'Obter segunda via de boleto', code: 2 },

]);


const hasPayments = computed(() => payments.value && payments.value.length > 0);
const temSegundaVia = ref(false);

const checkSegundaVia = async () => {
    try {
        const res = await axios.get(`/contract-ws/${contractData.value.contrato_id}/plots-count`);
        if (res.data?.result?.parcelas?.segunda_via > 0) {
            temSegundaVia.value = true;
        }
    } catch (e) { /* ignore */ }
};

onMounted(async () => {
    checkSegundaVia();
    getNextPayments();
});

const getNextPayments = async () => {
    try {
        const response = await axios.get(`/clients/contract/${contractData.value.contrato_id}/plots?status=EM_ATRASO`);
        payments.value = response.data;
        sumTotalNextPayments();
        loading.value = false;
    } catch (error) {
        console.error(error);
    }
};

const currencyFormat = (value, currency = false) => {
    const options = {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };

    const formattedValue = new Intl.NumberFormat('pt-BR', options).format(value);

    if (currency) {
        return `${formattedValue}`;
    }

    return formattedValue;
};

const sumTotalNextPayments = () => {
    totalPayments.value = payments.value.reduce((acc, payment) => acc + parseFloat(payment.valorcorrigido), 0);
};

const formatDate = (date) => {
    return moment(date).format('DD/MM/YYYY');
};

const toggleSelection = (paymentId) => {
    const index = selectedPayments.value.indexOf(paymentId);
    if (index === -1) {
        selectedPayments.value.push(paymentId); // If not selected, add to selectedPayments
    } else {
        selectedPayments.value.splice(index, 1); // If already selected, remove from selectedPayments
    }
    updateTotals()
};

const updateTotals = () => {
    totalFees.value = payments.value
        .filter(item => selectedPayments.value.includes(item.par_in_codigo))
        .reduce((acc, item) => acc + parseFloat(item.valor_juros), 0);

    totalSelected.value = payments.value
        .filter(item => selectedPayments.value.includes(item.par_in_codigo))
        .reduce((acc, item) => acc + parseFloat(item.valorcorrigido), 0);
}

const sendRequest = () => {
    try {
        if (!date.value || !email.value || !selectedOption.value) {
            showToast('Campos obrigatórios não preenchidos', 'error')
            return;
        }

        if (selectedOption.value.code == 1) { // 1 - Solicitação de Renegociação
            requestRenegotiation()
        } else if (selectedOption.value.code == 2) { // 2 - Segunda via
            requestDuplicate()
        }
    } catch (error) {
        console.log(error);
    }
}

const requestRenegotiation = async () => {
    try {
        loadingButton.value = true
        const data = {
            data_solicitacao: date.value,
            parcelas: selectedPayments.value,
            unit: {
                contract_id: contractData.value.contrato_id,
                property: contractData.value.torre,
                description: contractData.value.contrato_unidade
            },
            email: email.value,
            origin_id: 2
        };
        const response = await axios.post(`/contact/requestLatePlots`, data);
        if (response.data) {
            showToast('Solicitação enviada com sucesso.', 'success')
        }
    } catch (error) {
        console.error(error)
        showToast('Não foi possivel solicitar a renegociação, tente novamente.', 'error');
    } finally {
        loadingButton.value = false
    }


}

const requestDuplicate = async () => {
    try {
        loadingButton.value = true
        const data = {
            parcel: selectedPayments.value,
            email: email.value,
            data_solicitacao: date.value,
            notificacao: true
        };
        const response = await axios.post(`/contract-ws/${contractData.value.contrato_id}/duplicate`, data);

        console.log(response.data.result)

        if (response.data) {
            showToast('Solicitação enviada com sucesso.', 'success')
        }
    } catch (error) {
        console.error(error)
        showToast('Não foi possivel solicitar a segunda via do boleto, tente novamente.', 'error');
    } finally {
        loadingButton.value = false
    }
}

</script>

<style>
.bg-color {
    background-color: #ededed !important;
}
</style>
